import React from "react";
import "./Produk.scss";
import data from "./data.json";
import Card from "../../Component/Card Viola/cardviola";
import Essenceimages from "../../Media/Residential/essence";
import Mahakamimages from "../../Media/Residential/Mahakam";
import Vastuimages from "../../Media/Residential/Vastu/Vastu";
import Cleonimages from "../../Media/Residential/Cleon Apart/apartcleon";
import Sentarumimages from "../../Media/Residential/Sentarum/Sentarum";
import Maninjauimages from "../../Media/Residential/Maninjau/Maninjau";
import kelimutuimages from "../../Media/Residential/Kelimutu/Kelimutu";
import Tobaimages from "../../Media/Residential/Toba/Toba";
import Coniveraimages from "../../Media/Residential/Conifera/Conivera";
import Raharjaimages from "../../Media/Residential/Raharja";
import Peonyimages from "../../Media/Residential/Peony";
import Whiteimages from "../../Media/Residential/White Rose/White";
import Saphirreimages from "../../Media/Residential/New Mahakam/Saphirre/Saphirre";
import Topazimages from "../../Media/Residential/New Mahakam/Topaz/Topaz";
import Maisonimages from "../../Media/Residential/Maison/Maison";
import Wisteriaimages from "../../Media/Residential/Wisteria/Wisteria";

const imageMap = {
  Essenceimages,
  Mahakamimages,
  Vastuimages,
  Cleonimages,
  Sentarumimages,
  Maninjauimages,
  kelimutuimages,
  Tobaimages,
  Coniveraimages,
  Raharjaimages,
  Peonyimages,
  Whiteimages,
  Topazimages,
  Saphirreimages,
  Maisonimages,
  Wisteriaimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="Residential" className="produk">
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
